import ProducerTable from "./ProducerTable";

export default ProducerTable;
